import React from 'react'
import { Tabs } from 'antd';
import { translate } from 'react-i18next'
import SupportStartedTab from './SupportStartedTab'
import SupportFaqsTab from './SupportFaqsTab'

const { TabPane } = Tabs;


const SupportMainTab = ({ t }) => {
    return (
        <Tabs className="support-tab" defaultActiveKey="1" centered>
            <TabPane tab={t('support_text.tab_1_header')} key="1">
                <SupportStartedTab />
            </TabPane>
            <TabPane tab={t('support_text.tab_2_header')} key="2" >
                <SupportFaqsTab />
            </TabPane>
        </Tabs>
    )
}

export default translate()(SupportMainTab)
